document.addEventListener('DOMContentLoaded', function () {
  const mainRender = document.querySelector(
    '[data-main-collection-render], [data-main-search-render]'
  )

  // Selectors adjusted for specific Shopify price range parameters
  const priceMinInput = document.querySelector(
    'input[name="filter.v.price.gte"]'
  )
  const priceMaxInput = document.querySelector(
    'input[name="filter.v.price.lte"]'
  )

  function updatePriceRange() {

    const priceRangeSliderMin = document.getElementById(
      'Filter-filter.v.price.gte'
    )
    const priceRangeSliderMax = document.getElementById(
      'Filter-filter.v.price.lte'
    )
    const priceRangeMinValue = document.getElementById('price-range-min-value')
    const priceRangeMaxValue = document.getElementById('price-range-max-value')
    const sliderSelection = document.querySelector('.slider-selection')

    const selectedMinValue = parseInt(priceRangeSliderMin.value)
    const selectedMaxValue = parseInt(priceRangeSliderMax.value)

    if (selectedMinValue > selectedMaxValue) {
      priceRangeSliderMin.value = selectedMaxValue
      priceRangeSliderMax.value = selectedMinValue
    }

    priceRangeMinValue.textContent = priceRangeSliderMin.value
    priceRangeMaxValue.textContent = priceRangeSliderMax.value

    // Update the slider selection color
    let minPercentage = (selectedMinValue / priceRangeSliderMax.max) * 100
    let maxPercentage = (selectedMaxValue / priceRangeSliderMax.max) * 100
    sliderSelection.style.left = `${minPercentage}%`
    sliderSelection.style.right = `${100 - maxPercentage}%`

  }

  function updateUrl(event) {
    let target = event.target
    let isSortSelect = target.matches('collection-sort select')
    let isFilter = target.matches(
      '[data-all-collection-filters] input, [data-all-collection-filters] select'
    )
    let isPriceInput = target.matches(
      'input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]'
    )

    if (!isSortSelect && !isFilter && !isPriceInput) {
      return // Ignore unrelated changes
    }

    let currentUrl = new URL(window.location)
    let newUrl = new URL(currentUrl)
    let searchParams = new URLSearchParams(currentUrl.search)

    // Dynamically get the price input elements from the DOM
    let dynamicPriceMinInput = document.querySelector(
      'input[name="filter.v.price.gte"]'
    )
    let dynamicPriceMaxInput = document.querySelector(
      'input[name="filter.v.price.lte"]'
    )

    if (isFilter && !isPriceInput) {
      if (
        (target.type === 'checkbox' && target.checked) ||
        (target.type === 'radio' && target.checked)
      ) {
        searchParams.append(target.name, target.value)
      } else {
        const pathWithoutFilter = target.getAttribute('data-url-to-remove')
        history.replaceState({ path: pathWithoutFilter }, '', pathWithoutFilter)
        renderSection()
      }
    }

    if (isSortSelect) {
      searchParams.set('sort_by', target.value)
    }

    // Handling for dynamic Shopify price range inputs
    if (isPriceInput) {
      if (dynamicPriceMinInput && dynamicPriceMinInput.value) {
        searchParams.set('filter.v.price.gte', dynamicPriceMinInput.value)
      } else {
        searchParams.delete('filter.v.price.gte')
      }

      if (dynamicPriceMaxInput && dynamicPriceMaxInput.value) {
        searchParams.set('filter.v.price.lte', dynamicPriceMaxInput.value)
      } else {
        searchParams.delete('filter.v.price.lte')
      }
    }

    newUrl.search = searchParams.toString()
    if (newUrl.toString() !== currentUrl.toString()) {
      history.replaceState({ path: newUrl.toString() }, '', newUrl.toString())
      renderSection()
    }
  }

  function renderSection() {
    const container = document.getElementById('ProductGridContainer')
    document.getElementById('product-grid').classList.add('loading')

    let fetchUrl = ''
    let sectionParam = ''

    if (window.location.pathname.includes('/collections/')) {
      fetchUrl = `${window.location.pathname}${window.location.search}`
      sectionParam = 'section_id=main-collection-product-grid'
    } else if (window.location.pathname.includes('/search')) {
      fetchUrl = `${window.location.pathname}${window.location.search}`
      sectionParam = 'section_id=main-search'
    }

    fetchUrl += window.location.search.includes('?')
      ? `&${sectionParam}`
      : `?${sectionParam}`

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((html) => {
        const newContent = new DOMParser().parseFromString(html, 'text/html')
        const newSection = newContent.querySelector('#ProductGridContainer')
        if (newSection) {
          if (container.parentNode) {
            container.parentNode.replaceChild(newSection, container)
          } else {
            console.error('Parent element not found for ProductGridContainer')
            // document.body.appendChild(newSection)
          }
        } else {
          console.error('New section content not found')
        }
      })
      .catch((error) => {
        console.error('Error fetching updated content:', error)
      })
      .finally(() => {
        setTimeout(() => {
          document.getElementById('product-grid').classList.remove('loading')
          initializeEventListeners()
        }, 800)
      })
  }

  function initializeEventListeners() {
    mainRender.addEventListener('change', updateUrl);
    mainRender.addEventListener('input', updatePriceRange)
  }

  initializeEventListeners()
  updatePriceRange()

})
